import styled from "styled-components";

interface ISearchProps{
    isOpen: boolean
}

export const Container = styled.header `
    background-color: ${props => props.theme.colors.brand4.dark};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    grid-area: header;
    z-index: 2;

    .nav__desktop--container {
        display: none;
    }

    @media(min-width:768px) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 57px;
        padding: 0;
        justify-content: center;

        .nav__desktop--container {
            display: block;
        }
    }   
`


export const BrandHeaderContainer = styled.div `
    padding: 14px 24px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media(min-width:480px) {
        padding: 24px 40px 40px;
    }

    @media(min-width:768px) {
        height: 100%;
        padding: 0 24px;
    }

    @media(min-width: 1024px) {
        padding: 0 104px;
    }
`

export const IconsHeaderNavigation = styled.div `
    display: flex;
    align-items: center;
    gap: 16px;
}
`
export const BrandHeader = styled.h2 `
    color: ${props => props.theme.colors.brand1.pure};
    text-transform: uppercase;
    font-weight: normal;
    font-size: 2.25rem;

    @media(min-width:480px) {
        font-size: 3rem;
        line-height: 59.7px;
    }

    @media(min-width:768px) {
        font-size: 1.25rem;
        line-height: 25px;
    }   
`

export const UserIconContainer = styled.div `

        .svg__user--button {
            border: 1px solid #FFFF;
            border-radius: 100%;
            cursor: pointer;

            height: 30px;
            width: 30px;
            
            @media(min-width:768px) {
                height: 30px;
                width: 30px;
            }   
        }
        
`
export const SearchButton = styled.button<ISearchProps>`
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    visibility: ${prop => prop.isOpen? 'hidden' : 'visible'};
    > svg {
        width: 32px;
        height: 30px;

        @media(min-width:768px) {
            width: 24px;
            height: 24px;   
        }
    }

    > span {
        font-size: 0.85rem;
        color: ${props => props.theme.colors.brand1.pure};
    }

    @media(min-width:768px) {
        margin-left: 30px;
    }
   
`
export const DivHeader = styled.div`
    display: flex;
` 
